export default __webpack_public_path__ + "static/media/infertility2.f02b7b78.jpg";